import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$body} from '../Constants';
import HelperUtility from '../Utility/HelperUtility';

/**
 * Javascript Wrapper for the ExpandableTeasers HTMLElement
 */
class ExpandableTeasers extends HtmlElement {
	onReady() {
		this.multiExpand = false;
		this.teasers = this.getTeasers();

		if(HelperUtility.atBreakpoint('medium')) {
			this.equalizeTeaser();
		}
	}

	getTeasers() {
		let teasers = [],
			_self = this;

		this.$element.find('.expandable-teaser').each(function() {
			teasers.push(new ExpandableTeaser($(this), _self));
		});

		return teasers;
	}

	equalizeTeaser() {
		let _self = this,
			heights = [],
			iconsArray = [],
			$icons;

		for(let i = 0; i < this.teasers.length; i++) {
			iconsArray.push(this.teasers[i].getIcon());
		}

		$icons = $(iconsArray).map(function(){return this.toArray();});

		HelperUtility.imagesLoaded($icons, function(index) {
			heights.push(_self.teasers[index].getHeight());
		}, function() {
			for(let i = 0; i < _self.teasers.length; i++) {
				_self.teasers[i].setHeight(Math.max(...heights));
			}

			_self.$element.addClass('equalized');
		});
	}

	closeTeasers(not) {
		for(let i = 0; i < this.teasers.length; i++) {
			if(this.teasers[i] !== not) {
				this.teasers[i].close();
			}
		}
	}
}

class ExpandableTeaser {
	constructor($teaser, expandableTeasers) {
		this.opened = false;

		this.$teaser = $teaser;
		this.expandableTeasers = expandableTeasers;
		this.$indicator = this.$teaser.find('.expandable-teaser-indicator');
		this.$expandableText = this.$teaser.find('.expandable-teaser-text');

		this.bindHandlers();
	}

	bindHandlers() {
		this.$indicator.stop(true, false).on('click', () => {
			if(!this.opened) {
				if(this.expandableTeasers.multiExpand  === false) {
					this.expandableTeasers.closeTeasers(this);
				}

				this.open();
			}else {
				this.close();
			}
		});
	}

	getHeight() {
		return this.$teaser.outerHeight(true);
	}

	setHeight(height) {
		this.$teaser.css('min-height', height);
	}

	getIcon() {
		return this.$teaser.find('.icon img');
	}

	open() {
		this.$teaser.addClass('opened');
		this.$expandableText.slideDown(300);
		this.opened = true;
	}

	close() {
		this.$expandableText.slideUp(300, () => {
			this.$teaser.removeClass('opened');
		});
		this.opened = false;
	}
}

let allExpandableTeasers = [];

$body.find('.expandable-teasers').each(function() {
	allExpandableTeasers.push(new ExpandableTeasers($(this)));
});

export default allExpandableTeasers;